import { readonly, shallowRef } from 'vue';

const currentTip = shallowRef(null);
let dismissTimer = null;

const clearDismissTimer = () => {
  if (!dismissTimer) return;
  clearTimeout(dismissTimer);
  dismissTimer = null;
};

export const hideBuyServiceTips = (id) => {
  if (id && currentTip.value?.id !== id) return;

  clearDismissTimer();
  currentTip.value = null;
};

export const showBuyServiceTips = ({ message, onClick }) => {
  clearDismissTimer();

  const id = Symbol('buy-service-tips');
  currentTip.value = {
    id,
    message,
    onClick,
  };

  dismissTimer = setTimeout(() => {
    hideBuyServiceTips(id);
  }, 30000);
};

export const buyServiceTips = readonly(currentTip);
